import React from 'react';

import { CorporateSubscriberCirclePartner } from '../../utils/backend-api/partners';
import styles from './styles.module.scss';

interface CorporateSubscriberCircleCardProps {
  partner: CorporateSubscriberCirclePartner;
}

const CorporateSubscriberCircleCard = ({ partner }: CorporateSubscriberCircleCardProps) => {
  const { name, tagline } = partner;
  return (
    <div className={styles.cscPartner}>
      {name}: {tagline}
    </div>
  );
};

export default CorporateSubscriberCircleCard;
